import React, { Component, Fragment } from 'react';
import { Row, Col, Card, Button, Table } from 'antd';
import { inject, observer } from 'mobx-react';
const ButtonGroup = Button.Group;

@inject('store')
@observer
export class LeaderboardView extends Component {
    constructor(props) {
        super(props);
        this.state = {
            pair: 'BTCUSD'
        };
    }

    async componentDidMount() {
        await this.getLeaderboards(this.state.pair);
    }

    async getLeaderboards(pair) {
        await this.props.store.odysseyBotStore.getTop10Leaderboard(pair);
    }

    render() {
        return (
            <Fragment>
                <Row gutter={24} type="flex" justify="center">
                    <Col md={5} style={{ textAlign: 'center' }}>
                        <ButtonGroup>
                            <Button
                                disabled={this.state.pair === 'BTCUSD'}
                                onClick={() => {
                                    this.setState({ pair: 'BTCUSD' });
                                    this.getLeaderboards('BTCUSD');
                                }}
                            >
                                BTC
                            </Button>
                            <Button
                                disabled={this.state.pair === 'ETHUSD'}
                                onClick={() => {
                                    this.setState({ pair: 'ETHUSD' });
                                    this.getLeaderboards('ETHUSD');
                                }}
                            >
                                ETH
                            </Button>
                            <Button
                                disabled={this.state.pair === 'XRPUSD'}
                                onClick={() => {
                                    this.setState({ pair: 'XRPUSD' });
                                    this.getLeaderboards('XRPUSD');
                                }}
                            >
                                XRP
                            </Button>
                        </ButtonGroup>
                    </Col>
                </Row>
                <Row gutter={24} type="flex" justify="center" style={{ marginTop: 15 }}>
                    <Col md={12}>
                        <Card
                            title={`${this.state.pair} - Top 50 Traders based on USD captured`}
                            bordered={false}
                        >
                            <Table
                                dataSource={this.props.store.odysseyBotStore.top10Leaderboard}
                                rowKey={'place'}
                                pagination={false}
                                columns={[
                                    {
                                        title: 'Place',
                                        dataIndex: 'place',
                                        key: 'place',
                                        render(text) {
                                            if (text === 1) {
                                                return (
                                                    <i
                                                        className="fal fa-medal"
                                                        style={{ color: '#FFD700', fontSize: 22 }}
                                                    ></i>
                                                );
                                            }

                                            if (text === 2) {
                                                return (
                                                    <i
                                                        className="fal fa-medal"
                                                        style={{ color: '#C0C0C0', fontSize: 22 }}
                                                    ></i>
                                                );
                                            }

                                            if (text === 3) {
                                                return (
                                                    <i
                                                        className="fal fa-medal"
                                                        style={{ color: '#A0522D', fontSize: 22 }}
                                                    ></i>
                                                );
                                            }
                                            return text;
                                        }
                                    },
                                    {
                                        title: 'Trader',
                                        dataIndex: 'trader',
                                        key: 'trader',
                                        render(text) {
                                            if (!text) return 'Unknown';
                                            return text;
                                        }
                                    },
                                    {
                                        title: 'Trades',
                                        dataIndex: 'trades',
                                        key: 'trades'
                                    },
                                    {
                                        title: 'Won',
                                        dataIndex: 'won',
                                        key: 'won'
                                    },
                                    {
                                        title: 'Lost',
                                        dataIndex: 'lost',
                                        key: 'lost'
                                    },
                                    {
                                        title: 'Win %',
                                        dataIndex: 'a',
                                        key: 'a',
                                        render(text, o) {
                                            if (o.won === 0) return '0%';
                                            return `${(100 * (o.won / o.trades)).toFixed(2)}%`;
                                        }
                                    },
                                    {
                                        title: 'Captured',
                                        dataIndex: 'gain',
                                        key: 'gain',
                                        render: text => {
                                            return `$${text.toFixed(
                                                this.state.pair === 'XRPUSD' ? 4 : 2
                                            )}`;
                                        }
                                    }
                                ]}
                            />
                        </Card>
                    </Col>
                </Row>
            </Fragment>
        );
    }
}



// WEBPACK FOOTER //
// ./src/Account/OdysseyBot/LeaderboardView/index.js